import { Modal } from 'antd';
import { BaseButton } from '../UI/BaseButton';

export type SaveMode = 'filter' | 'display' | 'view';

interface ConfirmSaveForEveryoneModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  mode: SaveMode;
}

const modalContent: Record<SaveMode, { title: string; description: string }> = {
  filter: {
    title: 'Save Filter changes for everyone in this view?',
    description: 'This action will affect what everyone has filtered out in this view.',
  },
  display: {
    title: 'Save Display changes for everyone in this view?',
    description: 'This action will affect how everyone views and organizes tasks in this view.',
  },
  view: {
    title: 'Save View changes for everyone?',
    description: 'This action will save the current view configuration for all team members.',
  },
};

export const ConfirmSaveForEveryoneModal = (props: ConfirmSaveForEveryoneModalProps) => {
  const { title, description } = modalContent[props.mode];

  return (
    <Modal
      title={title}
      open={props.isOpen}
      onCancel={props.onCancel}
      onClose={props.onCancel}
      footer={null}
      width={640}
      centered
    >
      <div className="flex flex-col gap-6">
        <p className="text-neutral-900 text-sm font-normal leading-tight">{description}</p>

        <div className="flex justify-end gap-2">
          <BaseButton size="large" type="secondary" onClick={props.onCancel}>
            Cancel
          </BaseButton>

          <BaseButton size="large" type="accent" onClick={props.onConfirm}>
            Yes, Save for All
          </BaseButton>
        </div>
      </div>
    </Modal>
  );
};
